import React, {Component} from 'react';
import {Popover} from "antd";

/**
 * creat by xcc
 * @description 气泡
 * @class TextPopover
 * @extends {Component}
 */
export default class textPopover extends Component {

    getMenu = (btnList = []) => {
        let {record, that} = this.props;
        return (
            <>
                {btnList.map((item, index) => {
                    return <div key={index} style={{padding: 5}} onClick={() => item.onClick(record, item, that)}>
                     <span style={{
                         color: "#0050B3",
                         cursor: "pointer"
                     }}>{item.name}</span>
                    </div>
                })}
            </>)
    }

    render() {
        let {name, btnList} = this.props;
        const menu = this.getMenu(btnList);
        return (
            <Popover content={menu} placement="bottomRight">
                <span style={{cursor: "pointer", color: "#0050B3", marginRight: 5}}>{name}</span>
            </Popover>
        )
    }

}